import {useState} from "react";
import {Button, Modal, Table, Tag, Typography} from "antd";
import {CSVLink} from "react-csv";
import {MessageOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";


export const GeneList = ({ fetchData, isLoading, data }) => {
  const [showSentence, setShowSentence] = useState(false)
  const [item, setItem] = useState({})

  const columns = [
    {
      key: 'gene',
      dataIndex: 'gene',
      title: 'Gene',
      render: item => <Link to={`/genes/${item.trim()}`}>{item}</Link>,
      sorter: (a, b) => a.gene.localeCompare(b.gene)
    },
    {
      key: 'association',
      dataIndex: 'association',
      title: 'Association',
      render: item => <Tag color={item === 'Verified' ? 'success' : item === 'Medium' ? 'warning' : item === 'Low' ? 'error' : 'default'}>{item}</Tag>,
      filters: [
        {
          text: 'Low',
          value: 'Low',
        },
        {
          text: 'Medium',
          value: 'Medium',
        },
        {
          text: 'High',
          value: 'High',
        },
        {
          text: 'Verified',
          value: 'Verified',
        },
      ],
      onFilter: (value, record) => record.association.indexOf(value) === 0,
    },
    {
      key: 'cosine',
      dataIndex: 'cosine',
      title: 'Cosine',
      render: item => <Tag color="processing">{item}</Tag>,
      sorter: (a, b) => a.cosine - b.cosine
    },
    {
      key: 'actions',
      title: 'Actions',
      render: (_, item) => <Button onClick={() => {
        setItem(item)
        setShowSentence(true)
      }} icon={<MessageOutlined />} />
    }
  ]

  const onChange = (pagination, filter, sorter) => {
    fetchData({
      page: pagination.current,
      per_page: pagination.pageSize,
      filter,
      sorter
    })
  }

  return(
    <>
      <Table pagination={{ total: data.total, current: data.current_page, pageSize: data.per_page }} onChange={onChange}  rowKey={r => r.id} loading={isLoading} dataSource={data.data} columns={columns} />
      <div style={{ textAlign: 'center' }}>
        <Button type="primary">
          <CSVLink filename="disease_gene.csv" data={data.data}>Download CSV</CSVLink>
        </Button>
      </div>
      <br />
      <Modal
        title={item.title}
        visible={showSentence}
        onOk={() => setShowSentence(false)}
        onCancel={() => setShowSentence(false)}
        centered
        destroyOnClose
        width={1000}
      >
        <Typography.Title level={4}>Abstract: </Typography.Title>
        <p>
          {item.abstract}
        </p>
        {item.doi !== '' ? <>
          <Typography.Title level={4}>DOI: </Typography.Title>
          <p>
            <a target="_blank" href={`https://doi.org/${item.doi}`}>{item.doi}</a>
          </p>
        </> : ''}
      </Modal>
      {/*<List
        size="large"
        loading={isLoading}
        pagination={true}
        bordered
        dataSource={data}
        footer={<div style={{ textAlign: 'center' }}><Button type="primary"><CSVLink filename="disease_gene.csv" data={data}>Download CSV</CSVLink></Button></div>}
        renderItem={item => (
          <List.Item
            actions={[<Button icon={<MessageOutlined />} onClick={() => {
              setItem(item)
              setShowSentence(true)
            }} />]}
          >
            <List.Item.Meta
              avatar={<Avatar style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}>{item.gene.trim()[0]}</Avatar>}
              title={<Typography.Title level={4}><Link to={`/genes/${item.gene.trim()}`}>{item.gene}</Link> <Tag color="processing">HGNC</Tag></Typography.Title>}
              description={<Typography.Title level={4}><Tag color={item.association === 'Verified' ? 'success' : item.association === 'Medium' ? 'warning' : item.association === 'Low' ? 'error' : 'default'}>{item.association}</Tag></Typography.Title>}
            />
          </List.Item>
        )}
      />*/}
    </>
  )
}